export const SOCIAL_URL = [
    {
        "name": "Facebook",
        "url": "https://www.facebook.com/huacatluong/",
        "icon": ""
    },
    {
        "name": "Instagram",
        "url": "https://www.instagram.com/huacatluong/",
        "icon": "",
        "qrUrl": "https://i.imgur.com/BwpeV3X.jpg"
    },
    {
        "name": "Zalo",
        "url": "http://zaloapp.com/qr/p/gzyl9m7mebjs",
        "icon": "",
        "qrUrl": "https://i.imgur.com/QDnxdQ5.jpg"
    },
    {
        "name": "Whatsapp",
        "url": "https://wa.me/qr/HBIVEN2MOFROP1",
        "icon": "",
        "qrUrl": "https://i.imgur.com/OkrJDgh.jpg"
    },
    {
        "name": "Snapchat",
        "url": "https://www.snapchat.com/add/hualuong?share_id=/BH6UtBoTqy0KXfTJ01SAw&locale=en_VN",
        "icon": "",
        "qrUrl": "https://i.imgur.com/uf61xzA.jpg"
    },
]

export const WORK_URL = [
    {
        "name": "LinkedIn",
        "url": "https://www.linkedin.com/in/huacatluong/",
        "icon": ""
    },
    {
        "name": "Resume",
        "url": "/resume",
        "icon": ""
    },
    {
        "name": "GitHub",
        "url": "https://github.com/Tichuottt",
        "icon": ""
    },
    {
        "name": "Catalee",
        "url": "https://catalee.netlify.app",
        "icon": ""
    },
]

export const FIREBASE_URL = "https://react-http-89f31-default-rtdb.asia-southeast1.firebasedatabase.app/"

